import { useEffect, useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import GlobalFooter from './GlobalFooter';
import { useAuth } from '../../hooks/useAuth';

export default function Layout({ children, variant = 'client' }) {
  const { user } = useAuth();

  const [welcomeOpen, setWelcomeOpen] = useState(false);
  const [welcomeStep, setWelcomeStep] = useState(0);

  const welcomeSteps = [
    {
      title: 'Bem-vindo ao MecSync',
      description:
        'Vamos te mostrar rapidamente onde ficam as principais funções para você começar sem perder tempo.',
    },
    {
      title: 'Cadastre clientes e veículos',
      description:
        'Comece cadastrando seus clientes e os veículos atendidos pela oficina. Esses dados serão usados nas ordens de serviço.',
    },
    {
      title: 'Crie sua primeira Ordem de Serviço',
      description:
        'Depois do cadastro, abra uma OS para registrar serviços, peças, valores e acompanhar o andamento do atendimento.',
    },
  ];

  useEffect(() => {
    if (!user?.email) return;

    const key = `mecsync-welcome-seen-${user.email}`;

    if (!localStorage.getItem(key)) {
      setWelcomeOpen(true);
    }
  }, [user]);

  const concluirBoasVindas = () => {
    if (user?.email) {
      const key = `mecsync-welcome-seen-${user.email}`;
      localStorage.setItem(key, '1');
    }

    setWelcomeStep(0);
    setWelcomeOpen(false);
  };

  const avancarBoasVindas = () => {
    if (welcomeStep < welcomeSteps.length - 1) {
      setWelcomeStep((step) => step + 1);
      return;
    }

    concluirBoasVindas();
  };

  const voltarBoasVindas = () => {
    setWelcomeStep((step) => Math.max(0, step - 1));
  };

  const reabrirBoasVindas = () => {
    setWelcomeStep(0);
    setWelcomeOpen(true);
  };

  return (
    <div className="min-h-screen bg-background text-foreground">
      {variant === 'gdn' ? null : <Sidebar />}

      <div
        className={
          variant === 'gdn'
            ? 'min-h-screen flex flex-col'
            : 'min-h-screen lg:pl-64 flex flex-col'
        }
      >
        <Header
          variant={variant}
          onOpenOnboarding={reabrirBoasVindas}
        />

        <main className="flex-1">
          {children}
        </main>

        <GlobalFooter />
      </div>

      {welcomeOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
          <div className="w-full max-w-md rounded-2xl border border-border bg-surface p-6 shadow-xl">
            <div className="mb-4 flex items-center justify-between">
              <span className="text-xs font-medium text-zinc-400">
                Passo {welcomeStep + 1} de {welcomeSteps.length}
              </span>

              <button
                type="button"
                onClick={concluirBoasVindas}
                className="text-sm text-zinc-400 transition-colors hover:text-white"
              >
                Pular
              </button>
            </div>

            <h2 className="mb-3 font-display text-xl font-bold">
              {welcomeSteps[welcomeStep].title}
            </h2>

            <p className="text-sm leading-relaxed text-zinc-300">
              {welcomeSteps[welcomeStep].description}
            </p>

            <div className="mt-6 flex items-center justify-between">
              <button
                type="button"
                onClick={voltarBoasVindas}
                disabled={welcomeStep === 0}
                className="rounded-lg border border-white/10 px-4 py-2 text-sm text-zinc-300 transition-colors hover:text-white disabled:cursor-not-allowed disabled:opacity-40"
              >
                Voltar
              </button>

              <button
                type="button"
                onClick={avancarBoasVindas}
                className="rounded-lg bg-orange-500 px-4 py-2 text-sm font-semibold text-black transition-colors hover:bg-orange-400"
              >
                {welcomeStep === welcomeSteps.length - 1
                  ? 'Começar a usar'
                  : 'Próximo'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}